import React from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

class ReactSlider extends React.Component {
  render() {
    var settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '20px',
          },
        },
      ],
    }

    return (
      <Slider {...settings}>
        {this.props.children &&
          this.props.children.map((obj, index) => {
            return <React.Fragment key={index}>{obj}</React.Fragment>
          })}
      </Slider>
    )
  }
}

export default ReactSlider
